module.exports = __webpack_public_path__ + "static/media/subscribeGuide2_Jap.929bdae6.png";